'use strict';
define([
    'angular',
    'modules/searchconsole/sites/sites.controller'
], function (angular, SitesController) {
    var app = angular.module('app.searchconsole.sites', []);
    app.controller('SitesController', SitesController);
    return app;
});
